export default __webpack_public_path__ + "static/media/ONT_low_cost_frontal_leds_on.51d00966.png";